import React from "react";

export default React.forwardRef(function KochavaIcon(props, ref) {
  return (
    <svg
      height="1em"
      viewBox="0 0 32 32"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <polygon
        fill="#014caa"
        points="16 2 18.82 12.12 29.31 11.67 20.57 17.48 24.23 27.33 16 20.8 7.77 27.33 11.43 17.48 2.69 11.67 13.18 12.12"
      />
    </svg>
  );
});
